import type { Department } from "@closer/shared";
import { Button, FormField, Modal, Select, Skeleton } from "@closer/ui";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";

import { api } from "../../lib/apiClient";
import { useAuth } from "../../lib/authContext";
import { tenantKey } from "../../lib/tenantQuery";

/**
 * Sözleşmeye ilgili departman bağlama (CLOS-112 `[074]`).
 *
 * ⚠ Yalnız AKTİF departmanlar listeleniyor. Arşivli bir departmanı atamak, sunucunun
 * reddini kullanıcıya denettirmek olurdu; üstelik `department_archived` uyarısı daha
 * doğduğu anda yeniden üretilirdi.
 */
export function ContractDepartmentDialog({
  open,
  onClose,
  onConfirm,
  isPending,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: (girdi: { departmentId: string }) => void;
  isPending: boolean;
}) {
  const { activeTenantId } = useAuth();
  const tenantId = activeTenantId!;
  const [secili, setSecili] = useState("");

  const departmanlar = useQuery({
    enabled: open,
    queryKey: tenantKey(tenantId, "departmanlar", "sozlesme-secimi"),
    queryFn: async () => (await api<Department[]>("/api/departments", { tenantId })).data,
  });

  const atanabilir = (departmanlar.data ?? []).filter((d) => d.archivedAt === null);

  useEffect(() => {
    if (open) setSecili("");
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Departman ekle"
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Vazgeç
          </Button>
          <Button
            onClick={() => onConfirm({ departmentId: secili })}
            loading={isPending}
            disabled={secili === ""}
          >
            Ekle
          </Button>
        </>
      }
    >
      {departmanlar.isPending ? (
        <div role="status" aria-label="Departmanlar yükleniyor">
          <Skeleton lines={2} />
        </div>
      ) : (
        <FormField label="Departman" required>
          <Select aria-label="Departman" value={secili} onChange={(e) => setSecili(e.target.value)}>
            <option value="">Seçin</option>
            {atanabilir.map((d) => (
              <option key={d.id} value={d.id}>
                {d.name}
              </option>
            ))}
          </Select>
        </FormField>
      )}
    </Modal>
  );
}
